import * as tslib_1 from "tslib";
import { memoryCacheClient } from "./memory-cache-client";
import { checksum } from "./checksum";
import { serialize } from "./serialize";
import { ms } from "./ms";
import { is } from "./is-type";
function toQueryString(params) {
    return Object.keys(params)
        .map(function (k) {
        if (Array.isArray(params[k])) {
            var values = params[k];
            return values.map(function (val) { return encodeURIComponent(k) + "[]=" + encodeURIComponent(val); }).join("&");
        }
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
    })
        .join("&");
}
var defaultInitRequest = {
    headers: {
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache"
    },
    mode: "same-origin",
    credentials: "same-origin"
};
function createServiceRequest(global, cacheClient) {
    if (global === void 0) { global = defaultInitRequest; }
    if (cacheClient === void 0) { cacheClient = memoryCacheClient; }
    return function (endpoint, init, cache, ttl) {
        if (cache === void 0) { cache = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var property, response, json;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (init.queryParams && Object.keys(init.queryParams).length > 0) {
                            endpoint = endpoint + "?" + toQueryString(init.queryParams);
                        }
                        init.headers = init.headers || {};
                        if (init.body && !init.headers["Content-Type"]) {
                            init.headers["Content-Type"] = "application/json";
                        }
                        for (property in global) {
                            if (Object.prototype.hasOwnProperty.call(global, property)) {
                                if (property in init && is.object(init[property])) {
                                    init[property] = Object.assign({}, global[property], init[property]);
                                }
                            }
                        }
                        if (!cache) return [3 /*break*/, 1];
                        return [2 /*return*/, cacheClient.set(checksum(serialize(Object.assign({ endpoint: endpoint }, global, init))), function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var response, json;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, fetch(endpoint, Object.assign({}, global, init))];
                                        case 1:
                                            response = _a.sent();
                                            return [4 /*yield*/, response.json()];
                                        case 2:
                                            json = _a.sent();
                                            return [2 /*return*/, response.ok ? json : Promise.reject(json)];
                                    }
                                });
                            }); }, ttl ? ms(ttl) : undefined)];
                    case 1: return [4 /*yield*/, fetch(endpoint, Object.assign({}, global, init))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        return [2 /*return*/, response.ok ? json : Promise.reject(json)];
                }
            });
        });
    };
}
var serviceRequest = createServiceRequest();
export { serviceRequest, createServiceRequest, toQueryString };
//# sourceMappingURL=service-request.js.map